import React, { useEffect, useState } from "react"
import PropTypes from "prop-types"
import { useDispatch, useSelector } from "react-redux"
import Switch from "../Switch/Switch"
import { showSnackBar } from "../Snackbar/Snackbar"
import { selectFeatureFlag } from "../../features/featureFlags/selectors"
import { ACCOUNTING_DAILY_CSV_EMAIL } from "../../config/featureFlagKeys"
import {
  getOwnDailyEmail,
  setOwnDailyEmail,
  getUserDailyEmail,
  setUserDailyEmail,
} from "../../features/accountingDailyCsv/accountingDailyCsv"

const AccountingDailyEmailSwitch = ({ userId }) => {
  const dispatch = useDispatch()
  const flagOn = useSelector(selectFeatureFlag(ACCOUNTING_DAILY_CSV_EMAIL))
  const [state, setState] = useState(null)
  const [saving, setSaving] = useState(false)

  useEffect(() => {
    if (!flagOn) return undefined
    let active = true
    const request = userId ? getUserDailyEmail(userId) : getOwnDailyEmail()
    dispatch(request).then((result) => {
      if (!active) return
      if (result.error) {
        setState(null)
        return
      }
      setState(result.payload)
    })
    return () => {
      active = false
    }
  }, [flagOn, userId, dispatch])

  if (!flagOn || !state?.eligible) return null

  const handleChange = async (enabled) => {
    setSaving(true)
    const request = userId
      ? setUserDailyEmail({ userId, enabled })
      : setOwnDailyEmail({ enabled })
    const result = await dispatch(request)
    setSaving(false)
    if (result.error) {
      showSnackBar('error', result.payload || 'Failed to update the setting')
      return
    }
    setState((prev) => ({ ...prev, enabled: result.payload?.enabled ?? enabled }))
  }

  return (
    <Switch
      checked={Boolean(state.enabled)}
      onChange={handleChange}
      disabled={saving}
      label={userId ? "Daily Accounting email" : "Email me this file daily"}
      size="sm"
    />
  )
}

AccountingDailyEmailSwitch.propTypes = {
  userId: PropTypes.string,
}

export default AccountingDailyEmailSwitch
